import type { ComponentProps } from "react";

import { ProviderSignature } from "./components/ProviderSignature";
import { SignatureField } from "./components/SignatureField";
import { SignatureSkeleton } from "./components/SignatureSkeleton";

type NoteSignatureProps = ComponentProps<typeof SignatureField> & {
  isLoading?: boolean;
  isProvider?: boolean;
};

export function NoteSignature({
  children,
  isLoading,
  isProvider,
  label,
  ...rest
}: NoteSignatureProps) {
  if (isLoading) return <SignatureSkeleton />;

  return (
    <SignatureField label={label} {...rest}>
      {isProvider ? <ProviderSignature>{children}</ProviderSignature> : children}
    </SignatureField>
  );
}
